<template>
  <section id="Filters" class="filters">
    <!-- マーカー：ベースしかない場合など、出さない時もある -->
    <template v-if="isShowMarkers">
      <template v-for="marker in markers">
        <Filter
          v-if="isShowFilter('markers', marker.id)"
          type="markers"
          :filter="marker"
          :opened="marker.opened || !selectable"
          :selectable="selectable"
          :point="point"
          :showPassedOnly="showPassedOnly"
          :filter-clicked-callback="filterClickedCallback"
        >
          <template #filter-info="props">
            <slot name="filter-info" :filter="props.filter"></slot>
          </template>
          <template #filter-group-name="props">
            <slot name="filter-group-name" :filter="props.filter" :selectable="props.selectable"></slot>
          </template>
          <template #filter-switch-end="props">
            <slot name="filter-switch-end" :filter="props.filter"></slot>
          </template>
        </Filter>
      </template>
    </template>

    <!-- 検索条件 -->
    <template v-for="searchCondition in searchConditions">
      <Filter
        v-if="isShowFilter('search_conditions', searchCondition.id)"
        type="search_conditions"
        :filter="searchCondition"
        :opened="searchCondition.opened || !selectable"
        :selectable="selectable"
        :point="point"
        :showPassedOnly="showPassedOnly"
        :filter-clicked-callback="filterClickedCallback"
      >
        <template #filter-info="props">
          <slot name="filter-info" :filter="props.filter"></slot>
        </template>
        <template #filter-group-name="props">
          <slot name="filter-group-name" :filter="props.filter" :selectable="props.selectable"></slot>
        </template>
        <template #filter-switch-end="props">
          <slot name="filter-switch-end" :filter="props.filter"></slot>
        </template>
      </Filter>
    </template>
  </section>
</template>

<script lang="ts">
// どう絞り込むかを文章で表現する準備中
// import { mapGetters } from 'vuex'

import { PropType } from "vue"
import Filter from "./Filter.vue"
import { Filters } from "@/services/Filters.ts"
import store from "@/store"

export default {
  components: { Filter },
  props: {
    /**
     * true: 選択可能
     * false: 選択不可、表示専用、凡例などヘルプ的な用途
     */
    selectable: {
      type: Boolean,
      default: true
    },
    /**
     * Point視点で見る時にわたす
     * 指定した場合、そのPointに該当するFilterのみ強調・もしくは表示に調整可能にする
     */
    point: {
      type: Object,
      default: () => {}
    },
    /**
     * pointと一緒に使う
     * true: pointが指定されているとき、pointが該当するFilterのみ非表示
     */
    showPassedOnly: {
      type: Boolean,
      default: true
    },
    /**
     * フィルタークリック時のコールバック関数
     * クリック時の処理を外部から受け取る
     *
     * @param {Filter} filter - クリックされたフィルター
     */
    filterClickedCallback: {
      type: Function as PropType<((filter: Filter) => void) | null>,
      default: null
    }
  },
  beforeMount() {
    if (!storelocator.search_conditions) {
      return
    }

    this.searchConditions = storelocator.search_conditions
  },
  data() {
    return {
      searchConditions: null,
    }
  },
  methods: {
  },
  computed: {
    /**
      * 現在のページ
      */
    page() {
      return storelocator.page
    },
    // mapGetters,
    markers() {
      if (!storelocator.markers) {
        return []
      }

      return storelocator.markers
    },
    /**
     * @returns true: マーカーの絞り込みを表示
     * マーカーが１つしかない場合は選ぶ余地がないので、非表示
     */
    isShowMarkers() {
      if (!storelocator.markers) {
        return false
      }

      if (storelocator.markers.length === 1
        && storelocator.markers[0].children?.length === 0) {
        return false
      }

      // Pointを指定するのは店舗ページなど=不要（ただ、少し乱暴かも）
      if (this.point) {
        return false
      }

      return true
    },
    /**
     * 選択中のマーカーID
     * マーカーによる表示制御（visible_markers）の再評価をリアクティブにするためstoreを参照する
     */
    selectedMarkers() {
      return store.state.filters.selectedMarkers
    },
    isShowFilter() {
      return (type, id) => {
        const filter = Filters.findById(type, id)

        // 取れない
        if (!filter) {
          return false
        }

        // 設定で表示対象外
        if (!Filters.isFilterVisible(filter, { page: this.page, place: 'filters' })) {
          return false
        }

        // マーカーによる表示制御で対象外（検索条件のみ設定される）
        if (type === Filters.TYPE_SEARCH_CONDITIONS
          && !Filters.isVisibleBySelectedMarkers(filter, this.selectedMarkers)) {
          return false
        }

        // グループなのに子がない
        if (filter.children && filter.children.length === 0) {
          return false
        }

        return true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
